import React from 'react';

const ProductsPage = () => {
  const products = [
    {
      id: 1,
      title: "Supplier Management",
      description: "Centralized platform for efficient supplier communication, performance tracking, and risk management.",
      image: "supplier-management-image.jpg"
    },
    {
      id: 2,
      title: "Purchase Requisition",
      description: "Automates purchase requisition creation and approval workflows to ensure a seamless, efficient, and compliant process.",
      image: "purchase-requisition-image.jpg"
    },
    {
      id: 3,
      title: "Contract Management",
      description: "Automates contract creation, storage, and monitoring to enhance contract compliance, mitigate risk, and enhance efficiency.",
      image: "contract-management-image.jpg"
    },
    {
      id: 4,
      title: "Spend Analytics",
      description: "Provides data-driven insights into an organization's spending patterns, enabling proactive cost management, vendor optimization, and better decision-making.",
      image: "spend-analytics-image.jpg"
    },
    {
      id: 5,
      title: "eSourcing",
      description: "Single platform for online sourcing events (Reverse/ Forward Auctions, RFPs, Tenders, etc.), and contract negotiation to enhance the sourcing process, and reduce costs.",
      image: "esourcing-image.jpg"
    },
    {
      id: 6,
      title: "eInvoicing",
      description: "Automates the invoicing process reducing manual errors, speeding up payment cycles, and improves financial control through real-time visibility.",
      image: "einvoicing-image.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
    

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Page Title */}
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-[#07071c]" >
            Our Products
          </h1>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div key={product.id} className="bg-white  overflow-hidden hover:shadow-lg transition-shadow duration-300">
              {/* Product Image */}
              <div className="h-48 bg-gray-200 flex items-center justify-center">
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Product Content */}
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3" style={{ color: '#333333' }}>
                  {product.title}
                </h3>
                <p className="text-gray-600 text-sm break-words whitespace-normal ">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default ProductsPage;